
import request   from '../Functions/ajax/request'


export default function FrontLoader ({ params })
{
	return { page: getPage(true, params), params };
}

async function getPage (retry=true, params)
{
	try
	{
		var properties = await request('/property/list')
		.config({ })
		.post();

		/**
		var properties = await request('/property/get-highlighted')
		.config({ })
		.post();
		 */
	}
	catch (update)
	{
		if (['DENIED', 'FORBIDDEN'].includes(update.ERROR_CODE))
		{
			throw { code: 401, throw_up: true };
		}

		if (update.ERROR_CODE) throw update;

		if (!retry) throw update;
	}

	return { properties: properties };
}